import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Alert,
  Row,
  Col,
  Modal,
  InputGroup,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  getCountryActiveListApi,
  sendOtpWithRegistrationApi,
} from "./RamNamBookCRUD";
import LoginPage from "../auth-pages/LoginPage";

/* ---------------- Validation Schema ---------------- */
const validationSchema = Yup.object({
  memberName: Yup.string()
    .min(3, "Name must be at least 3 characters long")
    .required("Name is required"),
  mobileNumber: Yup.string()
    .matches(/^[0-9]{9,10}$/, "Please enter a valid mobile number")
    .required("Mobile number is required"),
  countryID: Yup.string().required("Please select a country"),
  villageCityName: Yup.string().required("Village / City name is required"),
  pincode: Yup.string()
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode")
    .required("Pincode is required"),
  address: Yup.string().required("Address is required"),
  termsAccepted: Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions")
    .required(),
});

const RamNamBookRegister = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [countries, setCountries] = useState([]);
  const handleCloseTerms = () => setShowTerms(false);
  const handleShowTerms = () => setShowTerms(true);
  const [showLogin, setShowLogin] = useState(false);
  // const countriesList = [
  //   {
  //     id: "1",
  //     name: "India",
  //     isoCode: "IND",
  //     dialCode: "+91",
  //     maxLength: 10,
  //   },
  //   {
  //     id: "2",
  //     name: "United States",
  //     isoCode: "USA",
  //     dialCode: "+1",
  //     maxLength: 10,
  //   },
  //   {
  //     id: "3",
  //     name: "United Kingdom",
  //     isoCode: "GBR",
  //     dialCode: "+44",
  //     maxLength: 10,
  //   },
  //   {
  //     id: "4",
  //     name: "Canada",
  //     isoCode: "CAN",
  //     dialCode: "+1",
  //     maxLength: 10,
  //   },
  // ];

  useEffect(() => {
    setLoading(true);
    getCountryActiveDataListApi();
  }, [100]);

  const getCountryActiveDataListApi = async () => {
    try {
      const res = await getCountryActiveListApi();
      if (res.data.isSuccess) {
        const activeCountries = res.data.responseObject;
        setCountries(activeCountries);
        setLoading(false);
      }
    } catch (err) {
      console.error("Country fetch error:", err);
      setCountries([]);
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      memberName: "",
      mobileNumber: "",
      countryID: "",
      villageCityName: "",
      pincode: "",
      address: "",
      termsAccepted: false,
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, setStatus }) => {
      // 🔗 CALL SEND OTP API HERE
      await sendOtpWithRegistrationApi(
        values.mobileNumber,
        values.memberName,
        values.countryID,
        values.villageCityName,
        values.pincode,
        values.address,
        values.termsAccepted
      )
        .then((response) => {
          if (response.data.isSuccess === true) {
            toast.success(`${response.data?.message}`);
            navigate("/verify-otp", {
              state: {
                otpdata: response.data?.data,
                mode: "registration",
                mobileNumber: values.mobileNumber,
              },
            });
          } else {
            toast.error(`${response.data?.message}`);
          }
        })
        .catch((error) => {
          toast.error(`${error.message}`);
        });
    },
  });

  /* --------- Mobile only numbers --------- */
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // only digits
    const regex = /^[6-9]\d{9}$/; // Indian mobile number

    if (value.length > 10) return;

    formik.setFieldValue("mobileNumber", value);

    // Validate only when 10 digits entered
    if (value.length === 10) {
      if (!regex.test(value)) {
        toast.error("Invalid mobile number");
      }
    }
  };

  /* ---------------- Mobile Change ---------------- */
  // const handleMobileChange = (e) => {
  //   const value = e.target.value.replace(/\D/g, "");
  //   if (value.length > 10) {
  //     showToast("મોબાઈલ નંબર 10 અંકથી વધુ ન હોવો જોઈએ");
  //     return;
  //   }
  //   setMobile(value);
  //   setMobileError("");
  // };

  return (
    <>
      {" "}
      <div
        className="container-fluid"
        style={{
          marginTop: "calc(var(--header-height) * -1)",
          minHeight: "100vh",
        }}
      >
        <Row
        // className="bg-light"
        // style={{
        //   marginTop: "calc(var(--header-height) * -1)",
        //   paddingTop: "0",
        // }}
        >
          {/* ================= LEFT HEADER ================= */}
          <Col
            lg={5}
            md={12}
            className="d-flex align-items-center justify-content-center text-center"
            style={{ backgroundColor: "#FF4F00" }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img
                src="/assets/logo/barejadham.png"
                alt="Khunkhaar Meldi Maa"
                className="img-fluid"
                style={{
                  maxWidth: "30vh",
                  cursor: "pointer",
                  animation: "pulseZoom 2.5s infinite",
                }}
                onClick={() => navigate("/")}
              />

              <h5 className="fw-bold text-white">
                શ્રી રામવાડી મેલડી માં [બરેજા ધામ]
                <p className="text-dark fs-6">શ્રી રામ નામ મંત્ર લેખન બેંક</p>
                <p className="text-white small mb-0 fs-5">
                  રામ નામ બુક નોંધણી | राम नाम बुक पंजीकरण | Ram Naam Book
                  Registration
                </p>
              </h5>
            </div>
          </Col>

          {/* ================= RIGHT FORM ================= */}
          <Col
            lg={7}
            md={12}
            className="d-flex align-items-center justify-content-center"
          >
            <Card className="shadow border-0 rounded-0 w-100 bg-white">
              {/* <div className="d-flex flex-column align-items-center justify-content-center">
                <img
                  src="/assets/logo/barejadham.png"
                  alt="Khunkhaar Meldi Maa"
                  className="img-fluid"
                  style={{
                    maxWidth: "60px",
                    cursor: "pointer",
                    animation: "pulseZoom 2.5s infinite",
                  }}
                  onClick={() => navigate("/")}
                />
              </div> */}
              <Card.Body className="p-md-5">
                {formik.status && (
                  <Alert variant="danger">{formik.status}</Alert>
                )}

                <Form noValidate onSubmit={formik.handleSubmit}>
                  {/* Name */}
                  <Form.Group className="mb-4">
                    <Form.Label>
                      સંપૂર્ણ નામ / पूरा नाम / Full Name{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="memberName"
                      placeholder="Enter your name"
                      value={formik.values.memberName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.memberName && !!formik.errors.memberName
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.memberName}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Mobile */}
                  {/*<Form.Group className="mb-2">
                    <Form.Label>
                      મોબાઈલ નંબર / मोबाइल नंबर / Mobile Number{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>

                    <InputGroup>
                      <InputGroup.Text>
                        {formik.values.dialCode || "+91"}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="mobileNumber"
                        value={formik.values.mobileNumber}
                        onChange={handleMobileChange}
                        onBlur={formik.handleBlur}
                        placeholder="XXXXXXXXXX"
                        isInvalid={
                          formik.touched.mobileNumber &&
                          !!formik.errors.mobileNumber
                        }
                      />{" "}
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        {formik.errors.mobileNumber}{" "}
                      </Form.Control.Feedback> */}
                  <Row className="mb-2">
                    <Col lg={6} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          મોબાઈલ નંબર / मोबाइल नंबर / Mobile Number{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <InputGroup>
                          {/* 🌍 Dial Code Dropdown */}
                          <Form.Select
                            value={formik.values.countryID}
                            onChange={(e) => {
                              const selected = countries.find(
                                (c) => c.countryID === Number(e.target.value)
                              );

                              formik.setFieldValue(
                                "countryID",
                                selected.countryID
                              );
                              formik.setFieldValue(
                                "dialCode",
                                selected.countryDialNumber
                              );
                              formik.setFieldValue("mobileNumber", ""); // reset number
                            }}
                            style={{ maxWidth: "120px" }}
                          >
                            {countries.map((c) => (
                              <option key={c.countryID} value={c.countryID}>
                                {c.countryDialNumber} ({c.countryCode})
                              </option>
                            ))}
                          </Form.Select>

                          {/* 📱 Mobile Number Input */}

                          <Form.Control
                            type="text"
                            name="mobileNumber"
                            value={formik.values.mobileNumber}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              formik.setFieldValue("mobileNumber", value);
                            }}
                            // placeholder="Mobile Number"
                            placeholder="Enter 10-digit mobile number"
                            maxLength={10} // UI level
                            minLength={9} // UI level
                            inputMode="numeric"
                            isInvalid={
                              formik.touched.mobileNumber &&
                              !!formik.errors.mobileNumber
                            }
                          />

                          <Form.Control.Feedback type="invalid">
                            {formik.errors.mobileNumber}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                      {/* Country */}
                      <Form.Group className="mb-2">
                        <Form.Label>
                          દેશ / देश / Country{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Select
                          name="countryID"
                          value={formik.values.countryID}
                          onChange={(e) => {
                            const selected = countries.find(
                              (c) => c.countryID === e.target.value
                            );

                            formik.setFieldValue("countryID", e.target.value);
                            formik.setFieldValue(
                              "countryName",
                              selected?.countryName || ""
                            );
                            formik.setFieldValue(
                              "countryISOCode",
                              selected?.countryCode || ""
                            );
                            // formik.setFieldValue(
                            //   "countryDialCode",
                            //   selected?.dialCode || ""
                            // );
                            // formik.setFieldValue("mobileNumber", "");
                          }}
                          isInvalid={
                            formik.touched.countryID &&
                            !!formik.errors.countryID
                          }
                        >
                          <option value="">Select Country</option>
                          {countries.map((c) => (
                            <option key={c.id} value={c.countryID}>
                              {c.countryName} ({c.countryCode})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col lg={6} md={6} sm={12}>
                      {/* Village */}
                      <Form.Group className="mb-2">
                        <Form.Label>
                          ગામ / गाँव / Village / City{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="villageCityName"
                          placeholder="Enter your village/city"
                          value={formik.values.villageCityName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.villageCityName &&
                            !!formik.errors.villageCityName
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                      {/* Pincode */}
                      <Form.Group className="mb-2">
                        <Form.Label>
                          પિનકોડ / पिनकोड / Pincode{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="xxxxxx"
                          name="pincode"
                          value={formik.values.pincode}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.pincode && !!formik.errors.pincode
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* Address */}
                  <Form.Group className="mb-4">
                    <Form.Label>
                      સરનામું / पता / Address{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Enter your address"
                      rows={2}
                      name="address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.address && !!formik.errors.address
                      }
                    />
                  </Form.Group>

                  {/* Terms */}
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      name="termsAccepted"
                      checked={formik.values.termsAccepted}
                      onChange={formik.handleChange}
                      label={
                        <>
                          {" "}
                          <span
                            style={{
                              color: "#FF4F00",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={handleShowTerms}
                          >
                            હું નિયમો અને શરતો સ્વીકારું છું/ I agree to the
                            terms & conditions
                          </span>
                        </>
                      }
                      isInvalid={
                        formik.touched.termsAccepted &&
                        !!formik.errors.termsAccepted
                      }
                    />
                  </Form.Group>

                  {/* Submit */}
                  <Button
                    type="submit"
                    className="w-100"
                    disabled={formik.isSubmitting}
                    style={{ backgroundColor: "#FF4F00" }}
                  >
                    {formik.isSubmitting
                      ? "Sending OTP..."
                      : "Submit & Get OTP"}
                  </Button>
                  <p className="text-center mt-2">
                    Already have an account?{" "}
                    <a
                      className="hover:underline text-primary"
                      onClick={() => setShowLogin(true)}
                    >
                      Login
                    </a>
                  </p>
                  <LoginPage
                    show={showLogin}
                    onHide={() => setShowLogin(false)}
                  />
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      {/* Animation */}
      <style>
        {`
          @keyframes pulseZoom {
            0% { transform: scale(1); }
            50% { transform: scale(1.08); }
            100% { transform: scale(1); }
          }
        `}
      </style>
      <Modal show={showTerms} onHide={handleCloseTerms} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#FF4F00" }}>
            Terms & Conditions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <p className="text-dark">
            કૃપા કરીને તમામ વિગતો ભરો અને નિયમો તથા શરતો સ્વીકારો. कृपया सभी
            विवरण भरें और नियम व शर्तें स्वीकार करें। <br />
            Please fill all details and accept the Terms & Conditions. <br />
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: "#FF4F00" }}
            onClick={handleCloseTerms}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RamNamBookRegister;
